<template>
  <div class="page">
    <!-- 头部 -->
    <div class="page-header">
      <el-divider content-position="left">内保单号（{{ formData.order_sn }}）</el-divider>
    </div>
    <!-- 基本信息 -->
    <BaseInfo
      :infoOptions="detailBaseInfoOption"
      :infoData="bill_data"
    />

    <!-- 信息 -->
    <el-tabs class="card-info shadow" type="border-card">
      <el-tab-pane label="申请信息">
        <el-form :model="formData" inline ref="formData" label-width="100px" class="demo-ruleForm">
          <el-form-item class="from-item--30" label="车辆" prop="plate_num">
            {{formData.plate_num}}
          </el-form-item>
          <el-form-item class="from-item--30" label="理赔员" prop="adjusters">
            {{formData.adjusters}}
          </el-form-item>
          <el-form-item class="from-item--30" label="创建时间" prop="createtime">
            {{formData.createtime}}
          </el-form-item>
          <el-form-item class="from-item--30 has-btn" label="姓名" prop="user_name">
            {{formData.user_name}}
          </el-form-item>
          <el-form-item class="from-item--30" label="手机号" prop="mobile">
            {{formData.mobile}}
          </el-form-item>
          <el-form-item class="from-item--30" label="事故地址" prop="address">
            {{formData.address}}
          </el-form-item>
          <el-form-item class="from-item--30" label="原因" prop="reason">
            {{formData.reason}}
          </el-form-item>
          <el-form-item class="from-item--30" label="受损部位" prop="info">
            {{formData.info}}
          </el-form-item>
          <el-form-item class="from-item--30" label="备注" prop="beizhu">
            {{formData.beizhu}}
          </el-form-item>
          <el-form-item class="from-item--30" label="状态" prop="status">
            {{formData.status}}
          </el-form-item>
          <el-form-item class="from-item--30" label="受理时间" prop="accepttime">
            {{formData.accepttime}}
          </el-form-item>
          <el-form-item class="from-item--10" label="事故照片" prop="accidentPhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="accidentPhoto" :limit="5"
              :on-preview="handlePictureCardPreview" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item class="from-item--10" label="受理照片" prop="acceptancePhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="acceptancePhoto" :limit="5"
              :on-preview="handlePictureCardPreview" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="维修信息">
        <el-form :model="formData" inline ref="car_data" label-width="100px" class="demo-ruleForm">
          <el-form-item class="from-item--30" label="维修厂" prop="store">
          {{formData.store}}
          </el-form-item>
          <el-form-item class="from-item--30" label="维修时间" prop="repairtime">
            {{formData.repairtime}}
          </el-form-item>
          <el-form-item class="from-item--10" label="维修照片" prop="repairPhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="repairPhoto" :limit="5"
              :on-preview="handlePictureCardPreview" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div style="display: flex;">
        <FoldedPanel style="width: 45%;margin-left: 3%;">
            <template #title>
              <span class="panel-header-text"><i class="icon el-icon-menu">维修项目</i></span>
            </template>
            <el-table :data="projectList" style="width: 100%">
              <!-- <el-table-column prop="isCheck" label="选择" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isCheck"></el-checkbox>
                </template>
              </el-table-column> -->
              <el-table-column prop="name" min-width="200" label="项目">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="工时(小时)">
                <template slot-scope="scope">
                  <span >{{scope.row.money}}</span>
                </template>
              </el-table-column>
            </el-table>
        </FoldedPanel>
        <FoldedPanel style="width: 45%;margin-left: 4%;">
            <template #title>
              <span class="panel-header-text"><i class="icon el-icon-menu">备件更换项目</i></span>
            </template>
            <el-table :data="partList" style="width: 100%">
              <!-- <el-table-column prop="isCheck" label="选择" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.isCheck"></el-checkbox>
                </template>
              </el-table-column> -->
              <el-table-column prop="name" min-width="200" label="项目">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.name }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="money" label="金额(元)">
                <template slot-scope="scope">
                  <span>{{scope.row.money}}元</span>
                </template>
              </el-table-column>
            </el-table>
        </FoldedPanel>
      </div>
      </el-tab-pane>
      <el-tab-pane label="完工信息">
        <el-form :model="formData" inline ref="car_data" label-width="100px" class="demo-ruleForm">
          <el-form-item class="from-item--30" label="车损维修金额" prop="money">
            {{formData.money}}
          </el-form-item>
          <el-form-item class="from-item--30" label="三者金额" prop="money">
            {{formData.szmoney}}
          </el-form-item>
          <el-form-item class="from-item--30" label="完工时间" prop="endtime">
            {{formData.endtime}}
          </el-form-item>
          <el-form-item class="from-item--10" label="完工照片" prop="completedPhoto" >
            <el-upload :action="$settings.uploadUrl.img + '/admin/upload/upimg'" name="img" multiple
              list-type="picture-card" :file-list="completedPhoto" :limit="5"
              :on-preview="handlePictureCardPreview" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="日志信息">
        <el-steps direction="vertical">
          <el-step v-for="log in logs" :key="log.id">
            <template #title>{{ log.operate_time }}</template>
            <template #description>
              <span>{{ log.user_name }}：</span>
              <span>{{ log.operate_content }}</span>
            </template>
          </el-step>
        </el-steps>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="preVisible">
      <img width="100%" :src="preImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { getToken } from "@/utils/auth";

import {
  detailBaseInfoOption,
} from "./formOptions";
export default {
  name: "Detail",
  comments: {},
  data() {
    return {
      keyword: "",
      preVisible: false,
      preImageUrl: "",
      bill_data: {},
      formData: {},
      // 附件相关
      accidentPhoto: [],
      repairPhoto: [],
      completedPhoto: [],
      acceptancePhoto: [],
      logs: [], // 日志信息
      projectList:[],
      partList:[]
    };
  },
  computed: {
    detailBaseInfoOption,
  },
  created() {
    this.handleSearh();
  },
  methods: {
    getToken,
    // 回显详情
    async handleSearh() {
    const { id } = this.$route.query;
      const res = await this.$api.post("/admin/accident/getDetails", {
        id: id,
      });
      
      this.accidentPhoto = res.data.accidentPhoto;
      this.repairPhoto = res.data.repairPhoto;
      this.completedPhoto = res.data.completedPhoto;
      this.acceptancePhoto = res.data.acceptancePhoto;
      this.projectList = res.data.projectList;
      this.partList = res.data.partList;
      // 回显日志信息
      this.logs = res.data.log;
      this.bill_data = res.data.base
      this.bill_data.days = this.$tools.getDaysBetween(
          res.data.base.beginTime,
          res.data.base.endTime
        ),
      this.formData = res.data.data;
      switch (this.formData.status) {
        case "1":
          this.formData.status = '等待中';
          break;
        case "2":
          this.formData.status = '事件受理';
          break;
        case "3":
          this.formData.status = '定损维修';
          break;
        case "4":
          this.formData.status = '完工交车';
          break;
        default:
          break;
      }
    },

    // 预览图片
    handlePictureCardPreview(file) {
      this.preImageUrl = file.url;
      this.preVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  padding: 15px;
  .page-header {
    width: 100%;
    display: flex;
    align-items: center;
    .header-inner {
      width: 40%;
      display: flex;
      align-items: center;
      .content {
        flex: 1;
      }
    }
  }

  .img-box {
    padding: 15px 0;
    display: flex;
    justify-content: space-between;
    .img-box-item {
      margin-left: 15px;
      border-radius: 4px;
    }
  }
}
.panel-detail-footer {
  display: flex;
  margin-top: 15px;
  justify-content: space-between;
  padding: 0 10px;
  align-items: center;
  .panel-detail-footer-left {
    display: flex;
    align-items: center;
    .label {
      white-space: nowrap;
    }
  }
}
/deep/.el-step__icon {
  border: 1px solid !important;
}
/deep/.el-icon-circle-close {
  color: #ef6027 !important;
}
// 附件标题
.enc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .encTitle {
    & > span {
      margin-left: 15px;
      font-size: 16px;
      color: #666;
    }
  }
  .encNum {
    font-size: 14px;
    color: #666;
    & > span {
      color: red;
      margin-right: 4px;
    }
  }
  .drawer-content {
    width: 100%;
    height: 100%;
  }
}
.from-item--30{
  width: 30%;
}
.from-item--10{
  width: 100%;
}
</style>
